import LocationModelBase from '../_generated/modelBases/location-model-base';

export default class LocationModel extends LocationModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
